import React, { FC, useContext, useState, useEffect } from 'react';
import { Card, Text } from '@gravity-ui/uikit';
import { STATUS_TO_THEME_MAP } from '../OperationStatus/OperationStatus';
import { CurrentAliceAppContext } from 'client/context/aliceAppContext';
import { DraftStatus } from 'client/model/draft';

import styles from './ModeratorNotes.module.scss';

const LAST_DISPLAYED_COMMENT = 'last_displayed_comment__';

const getLastComment = (userUid: string) => {
    let lastComment: string | null = '';
    try {
        lastComment = localStorage.getItem(LAST_DISPLAYED_COMMENT + userUid);
    } catch (_e) {
        console.error('localStorage.getItem is not available');
    }
    return lastComment;
};

const setLastComment = (userUid: string, comment: string) => {
    try {
        localStorage.setItem(LAST_DISPLAYED_COMMENT + userUid, comment);
    } catch (_e) {
        console.error('localStorage.setItem is not available');
    }
};

export const ModeratorNotes: FC = () => {
    const [showModerationNotes, setShowModerationNotes] = useState(false);
    const { aliceApp, lastOperationComment, lastOperationType } = useContext(CurrentAliceAppContext)!;
    const { user } = __appConfig;

    const userUid = user?.blackbox?.uid || '';

    useEffect(() => {
        const lastSavedComment = getLastComment(userUid);
        if (lastOperationComment && lastSavedComment !== lastOperationComment) {
            setShowModerationNotes(true);
            setLastComment(userUid, lastOperationComment);
        }
    }, [lastOperationComment, userUid]);

    if (
        !lastOperationType ||
        !lastOperationComment ||
        aliceApp.draft.status !== DraftStatus.InDevelopment ||
        !showModerationNotes
    )
        return null;

    return (
        <Card className={styles.moderationNotesContainer} theme={STATUS_TO_THEME_MAP[lastOperationType]?.theme}>
            <Text className={styles.moderationHeader} color={STATUS_TO_THEME_MAP[lastOperationType]?.color}>
                {STATUS_TO_THEME_MAP[lastOperationType]?.icon}
                {STATUS_TO_THEME_MAP[lastOperationType]?.label}
            </Text>
            <p className={styles.moderationText}>{lastOperationComment}</p>
        </Card>
    );
};
